import { render, staticRenderFns } from "./AdjustmentsList.vue?vue&type=template&id=bd76b880&scoped=true&"
import script from "./AdjustmentsList.vue?vue&type=script&lang=js&"
export * from "./AdjustmentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd76b880",
  null
  
)

export default component.exports